import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=18c2206e&scoped=true"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"
import style0 from "./Status.vue?vue&type=style&index=0&id=18c2206e&prod&scoped=true&lang=css"
import style1 from "./Status.vue?vue&type=style&index=1&id=18c2206e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c2206e",
  null
  
)

export default component.exports